import api from "@/services/api";

const state = {
  members: [],
  invitations: [],
  limit: null,
  used: null,
};

const mutations = {
  SET_MEMBERS(state, members) {
    state.members = members;
  },
  SET_INVITATIONS(state, invitations) {
    state.invitations = invitations;
  },
  SET_LIMIT(state, { limit, used }) {
    state.limit = limit;
    state.used = used;
  },
};

const actions = {
  async sendInvite({ dispatch }, payload) {
    const res = await api.post("/team/invite", payload);
    await Promise.all([dispatch("getInvitations"), dispatch("getLimit")]);
    return res.data;
  },

  async getLimit({ commit }) {
    const res = await api.get("/team/limit");
    commit("SET_LIMIT", res.data);
    return res.data;
  },

  async getMembers({ commit }) {
    const res = await api.get("/team/members");
    commit("SET_MEMBERS", res.data);
    return res.data;
  },

  async getInvitations({ commit }) {
    const res = await api.get("/team/invitations");
    commit("SET_INVITATIONS", res.data);
    return res.data;
  },

  async revokeInvite({ dispatch }, id) {
    const res = await api.put(`/team/invitations/${id}/revoke`);
    await Promise.all([dispatch("getInvitations"), dispatch("getLimit")]);
    return res.data;
  },

  async updateMemberRole({ dispatch }, { id, teamRole }) {
    const res = await api.put(`/team/members/${id}/role`, { teamRole });
    await dispatch("getMembers");
    return res.data;
  },

  async deactivateMember({ dispatch }, id) {
    const res = await api.put(`/team/members/${id}/deactivate`);
    await dispatch("getMembers");
    return res.data;
  },

  async removeMember({ dispatch }, id) {
    const res = await api.delete(`/team/members/${id}`);
    await Promise.all([dispatch("getMembers"), dispatch("getLimit")]);
    return res.data;
  },

  // Public — no session required, used by accept-invite.vue.
  async getInviteDetails(_, token) {
    const res = await api.get(`/team/invitations/by-token/${token}`);
    return res.data;
  },

  async acceptInvite(_, { token, payload }) {
    const res = await api.post(`/team/invitations/by-token/${token}/accept`, payload);
    return res.data;
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
